interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  onHistoryClick: () => void;
  onSettingsClick: () => void;
  onAboutClick: () => void;
  onLogoutClick?: () => void;
}

export function Sidebar({ isOpen, onClose, onHistoryClick, onSettingsClick, onAboutClick, onLogoutClick }: SidebarProps) {
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
          aria-hidden="true"
        />
      )}
      <aside
        className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-gray-800 border-r border-gray-700 transform transition-transform duration-300 lg:translate-x-0 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="p-4 border-b border-gray-700">
          <h2 className="text-xl font-bold text-green-400">Menu</h2>
        </div>
        <nav className="p-4 space-y-2">
          <button
            onClick={() => { onHistoryClick(); onClose(); }}
            className="w-full px-4 py-3 text-left bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors flex items-center gap-3"
          >
            <span>📈</span> Historique
          </button>
          <button
            onClick={() => { onSettingsClick(); onClose(); }}
            className="w-full px-4 py-3 text-left bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors flex items-center gap-3"
          >
            <span>⚙️</span> Paramètres
          </button>
          <button
            onClick={() => { onAboutClick(); onClose(); }}
            className="w-full px-4 py-3 text-left bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors flex items-center gap-3"
          >
            <span>ℹ️</span> À propos
          </button>
          {onLogoutClick && (
            <button
              onClick={() => { onLogoutClick(); onClose(); }}
              className="w-full px-4 py-3 text-left bg-gray-700 hover:bg-red-900/50 text-white font-medium rounded-lg transition-colors flex items-center gap-3"
            >
              <span>🚪</span> Déconnexion
            </button>
          )}
        </nav>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-700">
          <p className="text-xs text-gray-500 text-center">
            My Price Tracker v1.0
          </p>
        </div>
      </aside>
    </>
  );
}